<template>
  <el-dialog
    append-to-body
    :title="title"
    :visible.sync="dialogFormVisible"
    width="600px"
    @close="close"
  >
    <el-form ref="form">
      <video width="100%" controls="controls">
        <source :src="image" type="video/mp4" />
      </video>
    </el-form>
    <!-- <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirm">确 定</el-button>
        </div> -->
  </el-dialog>
</template>

<script> 

  export default {
    name: 'VideoShow',
    data() {
      return {
        image: '',
        title: '',
        dialogFormVisible: false,
      }
    },
    created() {},
    methods: {
      show(url, title) {
        this.title = title
        this.image = url
        this.dialogFormVisible = true
      },

      close() {
        this.$refs['form'].resetFields()
        this.form = this.$options.data().form
        this.dialogFormVisible = false
      },
    },
  }
</script>



// WEBPACK FOOTER //
// VideoShow.vue?cfbb9442